import { apiErrors } from 'constants/apiErrors';

const { defaultError, error401, error403, error404, error500, noResponseError } = apiErrors;

export default class APIErrorsHandlingUtils {
  /**
   * Розбирає помилку запиту на вид і код.
   *
   * У сховищі лишається саме вид, а не готовий текст: сайт двомовний, і мова
   * може змінитися після того, як помилка вже сталася. Текст добирає
   * компонент ErrorState під час рендеру.
   *
   * Види:
   *   network   — відповіді не було взагалі (немає мережі, сервер лежить)
   *   notFound  — 404, запису чи розділу немає
   *   forbidden — 401 і 403
   *   server    — 5xx
   *   client    — інші 4xx
   *   unknown   — помилка сталася ще до відправлення запиту
   */
  static classify(error) {
    if (error?.response) {
      const { status } = error.response;

      if (status === 404) return { kind: 'notFound', status };
      if (status === 401 || status === 403) return { kind: 'forbidden', status };
      if (status >= 500) return { kind: 'server', status };
      return { kind: 'client', status };
    }

    if (error?.request) return { kind: 'network', status: null };

    return { kind: 'unknown', status: null };
  }

  /**
   * Готові рядки українською для каталогів e-phan API.
   */
  static handleErrors(error) {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 400:
          return this.handle400Errors(data.errors || {});
        case 401:
          return [error401];
        case 403:
          return [error403];
        case 404:
          return [error404];
        case 500:
          return [error500];
        default:
          return [defaultError];
      }
    } else if (error.request) {
      return [noResponseError];
    } else {
      return [defaultError];
    }
  }

  static handle400Errors(errorsObject) {
    return Object.values(errorsObject || {});
  }
}
